<template>
  <!-- topic browse displays -->
  <div>
    <!-- {{pages}} -->
    <!--<template v-for="(chip, i) of selectedAuthors">-->
      <!-- {{chip}} -->
    <!--  <span class="chip" :key="i">{{chip}}-->
    <!--  <font-awesome-icon icon="times-circle" v-on:click="selectedAuthors = selectedAuthors.filter(x => x != chip)" />-->
        <!--<button type="button" class="chip-remove"-->
        <!--  v-on:click="selectedAuthors = selectedAuthors.filter(x => x != chip)"></button>-->
    <!--  </span>-->
    <!--</template>-->
    <!--<hr />-->
    <input type="text" v-model.trim.lazy="author" placeholder="Search author"/>
    <!-- {{pages}} {{filteredAuthors.length}} -->
    <div class="authors">
    <template v-for="(item) in Object.keys(index).sort()">
      <span :key="item" >
        <!--<img alt="blank"-->
        <!--  src="http://www.ikgf.uni-erlangen.de/aigaion2/webcontent/themes/default/icons/tree_blank.gif" class="icon">-->
        <span @click="filterByIndex(item)"
          :class="(authorIndex === item) ? 'selectedAuthorIndex' : 'notSelectedAuthorIndex'">{{item}}</span>
        <!-- <a _v-on:click.stop.prevent="browsebycategory(item)" :href="'http://www.ikgf.uni-erlangen.de/aigaion2/index.php/topics/single/'+(index+1)" :style="'margin-left:'+ ((item.split(' ')[0].replace(/[0-9]*/g,'').length -1)/2 * 20)+'px;'" >{{item}}</a> <template v-if="items[index+1] && ((items[index+1]).split(' ')[0].replace(/[0-9]*/g,'').length >1) && (item.split(' ')[0].replace(/[0-9]*/g,'').length == 1)" ><a href='#' :data="item.split(' ')[0].split('.',2).join('_')" onClick="$('.'+ $(this).attr('data')).toggle(); $(this).text($(this).text()==='+'?'-':'+')">+</a></template> -->
        <!--<span title="read: 0 of 32 publications"><i> 0/32</i></span>-->
      </span>
    </template>
    </div>
    <hr />
    <!-- {{getPages()}} -->
    <Paginate v-if="getPages().length > 1" :noofpages="getPages()" :page="page" v-on:goto="pageSelect" :noperpage="noPerPage" :showrecordscount="false" :maxofrecords="filteredAuthors.length"></Paginate>
    <!-- <div class="row">
        <template v-for="(item) in filteredAuthors">

            <div class="col-sm-4" :key="item"><input type="checkbox" v-model="selectedAuthors" :value="item">
              <text-highlight :queries="author.split(' ')" :caseSensitive="false">{{ item }}</text-highlight>
            </div>

          </template>
    </div> -->
    <div class="row">
        <template v-for="(item) in (displayedAuthors.filter(x => x.length > 0))">
            <!-- <img alt="blank"
            src="http://www.ikgf.uni-erlangen.de/aigaion2/webcontent/themes/default/icons/tree_blank.gif" class="icon"> -->
            <div class="col-sm-4 displayedAuthors" :key="item" ><input type="checkbox" v-model="selectedAuthors" :value="item"/>
              <text-highlight :queries="hightLightExpands(author.split(' '))" :caseSensitive="false" onClick="this.parentNode.querySelector('input').click();" >{{ item }}</text-highlight>
            </div>
            <!-- <li>{{item}}</li> -->
            <!-- <a _v-on:click.stop.prevent="browsebycategory(item)" :href="'http://www.ikgf.uni-erlangen.de/aigaion2/index.php/topics/single/'+(index+1)" :style="'margin-left:'+ ((item.split(' ')[0].replace(/[0-9]*/g,'').length -1)/2 * 20)+'px;'" >{{item}}</a> <template v-if="items[index+1] && ((items[index+1]).split(' ')[0].replace(/[0-9]*/g,'').length >1) && (item.split(' ')[0].replace(/[0-9]*/g,'').length == 1)" ><a href='#' :data="item.split(' ')[0].split('.',2).join('_')" onClick="$('.'+ $(this).attr('data')).toggle(); $(this).text($(this).text()==='+'?'-':'+')">+</a></template> -->
            <!--<span title="read: 0 of 32 publications"><i> 0/32</i></span>-->
          </template>
    </div>  
  </div>
  <!-- End of topic browse displays -->
</template>

<script>
  // @ is an alias to /src
  // import fetchJsonp from 'fetch-jsonp'
  import Vue from 'vue'
  import TextHighlight from 'vue-text-highlight'
  import Paginate from '../components/Paginate'
  import range from 'lodash.range'

  Vue.component('text-highlight', TextHighlight)
  import ChineseTranslator from '../assets/chineseTranslator'

  const normalize = function (str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[.,/#!$%^&*;:{}=\-_`~()ʻ"“]/gm, "").toUpperCase()
  }

  export default {
    name: 'authors',
    data: function () {
      return {
        authorIndex: "",
        author: "",
        filteredAuthors: [],
        // selectedAuthors: [],
        page: 0,
        noPerPage: 100,
        // unfolded: {}
      }
    },
    components: {
      Paginate
    },
    computed: {
      displayedAuthors(){
        // console.log(this.page,(this.page) * this.noPerPage, Math.min(((this.page + 1)* this.noPerPage - 1), this.filteredAuthors.length - 1))
        // console.log(this.filteredAuthors.slice((this.page-1) * this.noPerPage, Math.min((this.page * this.noPerPage - 1), this.filteredAuthors.length - 1)))
        return this.filteredAuthors.slice(this.page * this.noPerPage, Math.min(((this.page + 1)* this.noPerPage), this.filteredAuthors.length))
      },
      authors() {
        return this.$store.getters.getAuthors
      },
      index() {
        // console.log(this.$store.getters.getAuthorsPages)
        return this.$store.getters.getAuthorsIndex
      },
      pages() {
        return Math.floor(this.filteredAuthors.length / this.noPerPage) + (this.filteredAuthors.length % this.noPerPage > 0 ? 1 : 0)
      },
      selectedAuthors: {
        set(val) {
          this.$store.dispatch('selectedAuthors', val)
          this.$store.dispatch('fetchPublications')  
        },
        get () {
          return this.$store.getters.getSelectedAuthors
        }
      }
    },
    watch: {
      // selectedAuthors: function (val) {
      //   this.$store.dispatch('selectedAuthors', val)
      // },
      author: function (val) {
        this.author = val.replace(/\s{2,}/gm, ' ')
        if (val.trim().length != 0) {
          this.filterByAuthor(val)
          this.authorIndex = ''
        }
      },
      index: function () {
        this.filterByIndex(Object.keys(this.index).filter(x => x.length > 0).sort()[0])
      }
    },
    created: function () {
      this.$store.dispatch('fetchAuthors')
    },
    mounted: function () {
      // console.log(this.displayedAuthors)
      // console.log(Object.keys(this.index).sort()[0])
      // this.selectedAuthors = this.$store.getters.getSelectedAuthors
    },
    methods: {
      // hightLight: function (item) {
      //   if (this.author.trim().length > 0) {
      //     return item.replace(new RegExp(this.author, "ig"), "<span class='selectedAuthorIndex'>$&</span>")
      //   } else {
      //     return item
      //   }

      // },
      pageSelect: function(val) {
        this.page = val
      },
      filterByIndex: function (index) {
        if (this.index) {
          this.authorIndex = index
          this.filteredAuthors = this.index[index].sort()
          this.author = ''
          this.page = 0
        }
      },
      filterByAuthor: function (index) {
        this.filteredAuthors = this.authors.filter(x => normalize(ChineseTranslator.toSimplified(x)).match(normalize(ChineseTranslator.toSimplified(index))))
        this.page = 0
      },
      getPages: function() {
        let totalPage = Math.floor(this.filteredAuthors.length / this.noPerPage + (this.filteredAuthors.length % this.noPerPage == 0 ? 0 :1));
        
        if (totalPage < 12){
          return range(0,totalPage);
        } else {
          let start = Math.max(0, this.page-5);
          let end = Math.min(start + 11, totalPage)
          if (start + 11 >  totalPage){
            end = totalPage;
            start = Math.max(0, end-11);
          }

          // var pages = [];
          
          return range(start, end)
          // for (var i= start; i< end; i++){
          //   pages.push(parseInt(i));
          // }
          // return pages;
          
        }


        // return Array.from(Array(this.pages),(x,i)=>{
          
        //   return i
          
        // })
        // new Array(this.pages).map((x,i)=>{
        //   console.log(i)
        //   return [i * this.noPerPage + 1, Math.min((i+1) * this.noPerPage, this.filterByAuthor.length)].join(" - ")
        // })
      },
      hightLightExpands: function(terms) {
        let termsCleaned = terms.map(x => x.replace(/"/gm, ''))        
        termsCleaned = termsCleaned.reduce((acc,term)=>{
          let sims = ChineseTranslator.toSimplified(term)
          let trads = ChineseTranslator.toTraditional(term)
          if (acc.indexOf(sims) == -1) {
            acc.push(sims)
          }
          if (acc.indexOf(trads) == -1) {
            acc.push(trads)
          }
          return acc
        },termsCleaned)
        
        return termsCleaned
      },
      // selectAuthor: function(author) {
      //   this.$refs[author].click()
      // }
    }
  }
</script>
<style>
  span.selectedAuthorIndex {
    font-weight: bold;
    text-decoration: normal
  }

  span.notSelectedAuthorIndex {
    font-weight: normal;
    text-decoration: underline
  }
  .authors span {
    padding-right: 0.3em;
  }
  .displayedAuthors span {
    padding-left: 0.3em;
  }
  .displayedAuthors:hover {
    background-color: #e5eef6;
  }
</style>